export enum PostStateEnum {
  Published = 1,
  Archived = 2,
}
